import {
  Home,
  Tools,
  Analytics,
  Events,
  AddComment,
  Trophy,
  UserMultiple,
  WatsonHealthBrushFreehand as BrushFreehand,
  Folder,
} from '@carbon/react/icons';

import { ReactComponent as Members } from '@assets/icons/members_icon.svg';
import { ReactComponent as GroupDetails } from '@assets/icons/group_icon.svg';
import { ReactComponent as ProgressTracker } from '@assets/icons/progress_tracker_icon.svg';
import { ReactComponent as Sprints } from '@assets/icons/sprint_icon.svg';
import { ReactComponent as Teams } from '@assets/icons/teams_icon.svg';
import { ReactComponent as SurveyIcon } from '@assets/icons/survey_icon.svg';
import { ReactComponent as TargetIcon } from '@assets/icons/target_icon.svg';
import { ReactComponent as AssetsIcon } from '@assets/icons/assets_icon.svg';

export interface RoutesItem {
  label: string;
  path?: string;
  Icon?: any;
  IconAlt?: any;
  id: string;
  type?: 'link' | 'menu' | 'sublink';
  options?: string[];
}
export interface RouteWithMatchpath extends RoutesItem {
  matchPath?: string;
}

interface Routes {
  home: RoutesItem;
  admin: {
    root: RoutesItem;
    groupDetails: RoutesItem;
    audience: RoutesItem;
    members: RoutesItem;
    teams: RoutesItem;
    segments: RoutesItem;
    surveys: RoutesItem;
    sprints: RoutesItem;
    businessGoals: RoutesItem;
    assets: RoutesItem;
  };
  tracking: RoutesItem;
  maintenance: RoutesItem;
  login: RoutesItem;
  microsoft: RoutesItem;
  pawprintAdmin: {
    root: RoutesItem;
    organisations: RoutesItem;
  };
}

const routes: Routes = {
  home: {
    id: 'home',
    label: 'Home',
    path: '/',
    Icon: Home,
  },
  admin: {
    root: {
      id: 'admin',
      label: 'Admin panel',
      path: '/admin',
      Icon: Tools,
    },
    groupDetails: {
      id: 'group-details',
      label: 'Group details',
      path: '/admin/group-details',
      Icon: GroupDetails,
      IconAlt: BrushFreehand,
    },
    businessGoals: {
      id: 'businessGoals',
      label: 'Business goals',
      path: '/admin/goals',
      Icon: TargetIcon,
    },
    audience: {
      id: 'audience',
      label: 'Audience',
      Icon: Teams,
      IconAlt: Events,
      type: 'menu',
      options: ['members', 'teams', 'segments'],
    },
    members: {
      id: 'members',
      label: 'Members',
      path: '/admin/group-members',
      Icon: Members,
      IconAlt: UserMultiple,
      type: 'sublink',
    },
    teams: {
      id: 'teams',
      label: 'Teams',
      path: '/admin/teams',
      Icon: Teams,
      IconAlt: Events,
      type: 'sublink',
    },
    segments: {
      id: 'segments',
      label: 'Segments',
      path: '/admin/segments',
      type: 'sublink',
    },
    surveys: {
      id: 'surveys',
      label: 'Surveys',
      path: '/admin/surveys',
      Icon: SurveyIcon,
      IconAlt: AddComment,
    },
    sprints: {
      id: 'sprints',
      label: 'Sprints',
      path: '/admin/sprints',
      Icon: Sprints,
      IconAlt: Trophy,
    },
    assets: {
      id: 'assets',
      label: 'Resource hub',
      path: '/admin/assets',
      Icon: AssetsIcon,
      IconAlt: Folder,
    },
  },
  tracking: {
    id: 'tracking',
    label: 'Progress tracker',
    path: '/tracking',
    Icon: ProgressTracker,
    IconAlt: Analytics,
  },
  maintenance: {
    id: 'maintenance',
    label: 'Maintenance',
    path: '/maintenance',
  },
  login: {
    id: 'login',
    label: 'Login',
    path: '/login',
  },
  microsoft: {
    id: 'microsoft',
    label: 'Microsoft Login',
    path: '/microsoft-redirect',
  },
  pawprintAdmin: {
    root: {
      id: 'pawprint-admin',
      label: 'home',
      path: '/pawprint-admin',
      Icon: Home,
    },
    organisations: {
      id: 'organisations',
      label: 'Organisations',
      path: '/pawprint-admin/organisations',
    },
  },
};

export const shouldImpersonate = (url: string) => {
  switch (true) {
    case url.startsWith('/check_auths/'):
    case url.startsWith('/admin_users/'):
    case url === 'login':
    case url === 'logout':
      return false;
    default:
      return true;
  }
};

export default routes;
